//+++++++++++++++++++++++++++++++++++++++++++++++++++++//
//+++++++++++    BEGIN CUSTOM.JS CONTENT    +++++++++++//
//+++++++++++++++++++++++++++++++++++++++++++++++++++++//
/**
 * Include your custom JavaScript here.
 *
 * We also offer some hooks so you can plug your own logic. For instance, if you want to be notified when the variant
 * changes on product page, you can attach a listener to the document:
 *
 * document.addEventListener('variant:changed', function(event) {
 *   let variant = event.detail.variant; // Gives you access to the whole variant details
 * });
 *
 * You can also add a listener whenever a product is added to the cart:
 *
 * document.addEventListener('product:added', function(event) {
 *   let variant = event.detail.variant; // Get the variant that was added
 *   let quantity = event.detail.quantity; // Get the quantity that was added
 * });
 *
 * If you are an app developer and requires the theme to re-render the mini-cart, you can trigger your own event. If
 * you are adding a product, you need to trigger the "product:added" event, and make sure that you pass the quantity
 * that was added so the theme can properly update the quantity:
 *
 * document.documentElement.dispatchEvent(new CustomEvent('product:added', {
 *   bubbles: true,
 *   detail: {
 *     quantity: 1
 *   }
 * }));
 *
 * If you just want to force refresh the mini-cart without adding a specific product, you can trigger the event
 * "cart:refresh" in a similar way (in that case, passing the quantity is not necessary):
 *
 * document.documentElement.dispatchEvent(new CustomEvent('cart:refresh', {
 *   bubbles: true
 * }));
 */


/**********************************************************
 * DOCUMENT.READY FUNCTION (RUN AFTER PAGE READY)
 **********************************************************/
//+++++++++++++++++++++++++++++++++++++++++++++++++++++//
//+++++++++++    BEGIN CUSTOM.JS CONTENT    +++++++++++//
//+++++++++++++++++++++++++++++++++++++++++++++++++++++//
/**
 * Include your custom JavaScript here.
 *
 * We also offer some hooks so you can plug your own logic. For instance, if you want to be notified when the variant
 * changes on product page, you can attach a listener to the document:
 *
 * document.addEventListener('variant:changed', function(event) {
 *   let variant = event.detail.variant; // Gives you access to the whole variant details
 * });
 *
 * You can also add a listener whenever a product is added to the cart:
 *
 * document.addEventListener('product:added', function(event) {
 *   let variant = event.detail.variant; // Get the variant that was added
 *   let quantity = event.detail.quantity; // Get the quantity that was added
 * });
 *
 * If you are an app developer and requires the theme to re-render the mini-cart, you can trigger your own event. If
 * you are adding a product, you need to trigger the "product:added" event, and make sure that you pass the quantity
 * that was added so the theme can properly update the quantity:
 *
 * document.documentElement.dispatchEvent(new CustomEvent('product:added', {
 *   bubbles: true,
 *   detail: {
 *     quantity: 1
 *   }
 * }));
 *
 * If you just want to force refresh the mini-cart without adding a specific product, you can trigger the event
 * "cart:refresh" in a similar way (in that case, passing the quantity is not necessary):
 *
 * document.documentElement.dispatchEvent(new CustomEvent('cart:refresh', {
 *   bubbles: true
 * }));
 */


/**********************************************************
 * DOCUMENT.READY FUNCTION (RUN AFTER PAGE READY)
 **********************************************************/

// Coupon Popup Code reconfigured to use a utm param instead of the deprecated cookie - SLS 051525

if (typeof(window._$) != "undefined") 
    doCouponCookieStuff();
else {
    window.addEventListener('vps:jquery:loaded', doCouponCookieStuff);
}

function doCouponCookieStuff() {
    let _cookie_vps_discount = "vps_discount_code";
    let _cookie_vps_discount_first_view = "vps_discount_first_view";

    let aff_CookieLength = 30;
    let aff_CookieName = "vps_affiliate_last";
    let aff_SourceParamName = "utm_source";
    let aff_MediumParamName = "utm_medium";
    let aff_CampaignParamName = "utm_campaign";
    let discountQueryParamName = "utm_discount_code"; // <== NEW PARAM TO READ

    let suppressUSI = false;

    let _getQueryStringValue = function (_param) {
        let aff_QueryStringPairs = document.location.search.substring(1).split("&");
        for (let i = 0; i < aff_QueryStringPairs.length; i++) {
            let aff_QueryStringParts = aff_QueryStringPairs[i].split("=");
            if (_param.toLowerCase() == aff_QueryStringParts[0].toLowerCase()) {
                return decodeURIComponent(aff_QueryStringParts[1] || '');
            }
        }
    };

    let utm_s = _getQueryStringValue(aff_SourceParamName) || "";
    utm_s = utm_s.toLowerCase();

    if (utm_s === "shopify") utm_s = "";

    if (utm_s) {
        if (utm_s === "awin" || utm_s === "buyat") utm_s = "aw";

        let exp = new Date();
        exp.setDate(exp.getDate() - aff_CookieLength);
        VPSCookieManager.setCookie(aff_CookieName, utm_s, "/", null, true, exp);
    }

    let utm_m = _getQueryStringValue(aff_MediumParamName);
    let utm_c = _getQueryStringValue(aff_CampaignParamName);

    if (utm_m && utm_c && utm_m.toLowerCase() === "email") {
        suppressUSI = true;
    }

    // NEW: Get discount code from URL instead of cookies
    let discountFromURL = _getQueryStringValue(discountQueryParamName);
    if (discountFromURL) {
        discountFromURL = discountFromURL.toUpperCase();
        VPSCookieManager.setCookie(_cookie_vps_discount, discountFromURL);
        VPSCookieManager.setCookie(_cookie_vps_discount_first_view, 1);
    }

    // Use cookie if set from above (or previous session)
    let vpsDiscCookie = VPSCookieManager.getCookie(_cookie_vps_discount);
    let vpsFirstView = VPSCookieManager.getCookie(_cookie_vps_discount_first_view);

    suppressUSI = suppressUSI || (vpsDiscCookie != "");

    let exp = new Date();
    exp.setDate(exp.getDate() + 1);

    if (suppressUSI) {
        VPSCookieManager.setCookie("usi_suppress_preCart_TT", "1", "/", "valuepetsupplies.com", true, "strict", exp);
        VPSCookieManager.setCookie("usi_suppress_activeCart_TT", "1", "/", "valuepetsupplies.com", true, "strict", exp);
    }

    let elem = document.getElementById("discount-message");
    if (elem && vpsDiscCookie) {
        elem.innerHTML = "<span class='herocoupon-green'><b>" + vpsDiscCookie + "</b> Coupon applied</span><span>Discount shown on Checkout page.</span>";
    } else {
        _$('#cart__coupon-container').hide();
    }

    if ((parseInt(vpsFirstView) === 1) && (vpsDiscCookie && vpsDiscCookie.length > 0)) {
        let vpsDiscAmt = vpsDiscCookie.replace(/[^0-9]/g, '');
        if (vpsDiscCookie.substr(0, 3) === "ARD" || vpsDiscCookie.substr(0, 3) === "VRD") {
            vpsDiscAmt = vpsDiscCookie.substr(3, 2);
        }
        _$('#coupon-applied-code').text(vpsDiscAmt);
        _$('#coupon-applied-popup').css('display', 'block');

        setTimeout(function () {
            _$('#coupon-applied-popup').css('display', 'none');
            VPSCookieManager.setCookie(_cookie_vps_discount_first_view, 0);
        }, 1500);
    }
}


// Cookie handler for coupon links on-site

document.addEventListener("DOMContentLoaded", function () {
    document.querySelectorAll('.apply-discount').forEach(function (el) {
        el.addEventListener('click', function () {
            const discountCode = el.getAttribute('data-discount');

            if (discountCode && typeof VPSCookieManager !== "undefined") {
                const code = discountCode.toUpperCase();
                VPSCookieManager.setCookie("vps_discount_code", code);
                VPSCookieManager.setCookie("discount_code", code);
                VPSCookieManager.setCookie("vps_discount_first_view", 1);
            }
        });
    });
});


// Homepage Learn More Toggle 

var learnMorestatus = "less";
function learnMore() {
  if (learnMorestatus == "less") {
    document.getElementById("home-showmore-section").classList.add("home-showmore-section-visible");
    document.getElementById("home-moreless-button__toggle-text").innerText = "Show Less";
    learnMorestatus = "more";
  } else if (learnMorestatus == "more") {
    document.getElementById("home-showmore-section").classList.remove("home-showmore-section-visible");
    document.getElementById("home-moreless-button__toggle-text").innerText = "Learn More";
    learnMorestatus = "less"
  }
}

// Collections Toggle

 (function() {
        document.addEventListener('DOMContentLoaded', (event) => {
			// Find the element with the class name 'expandable-section'
			const expandableSection = document.querySelector('.expandable-section');
            const expandableToggle = document.querySelector('.expandable-toggle');
            if (expandableSection) {
                expandableSection.parentNode.insertBefore(expandableToggle, expandableSection);
                expandableToggle.classList.add ("expandable-toggle-right");
    			// Add a click event listener to the clickable div
    			expandableToggle.addEventListener('click', function() {
    			// Check the current display style of the 'expandable-section' and toggle it
    			if (expandableSection.style.display === 'none' || expandableSection.style.display === '') {
    			expandableSection.style.display = 'block';
                expandableToggle.classList.remove ("expandable-toggle-right"); 
    			expandableToggle.classList.add ("expandable-toggle-down"); 
    			} else {
    			expandableSection.style.display = 'none';
    			expandableToggle.classList.remove ("expandable-toggle-down"); 
    			expandableToggle.classList.add ("expandable-toggle-right"); 
    			}
    			});
            }
		});
      })();
